import Core from 'src/Core'

export default (superclass) => class extends superclass {
  findUserWithEmail () {
    return Core.publicWrapper({
      name: 'findUserWithEmail',
      arguments: arguments,
      parameters: ['userEmail', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'userEmail', presence: true, type: 'string' },
      ],
    })
  }

  getHome () {
    return Core.publicWrapper({
      name: 'getHome',
      arguments: arguments,
      parameters: ['onSuccess', 'onFailure', 'onComplete'],
    })
  }

  getCardDetails () {
    return Core.publicWrapper({
      name: 'getCardDetails',
      arguments: arguments,
      parameters: ['onSuccess', 'onFailure', 'onComplete'],
    })
  }

  getRewards () {
    return Core.publicWrapper({
      name: 'getRewards',
      arguments: arguments,
      parameters: ['onSuccess', 'onFailure', 'onComplete'],
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Loyalty.js